import type { JSX } from 'react'
import type { ILabelProps } from 'atoms/Label'
import type { ILabelGroupProps } from '../LabelGroup'

import { DolbyAtmosLabelIcon } from 'atoms/Icon/Templates'
import {
  LabelInlineSecondaryTemplate,
  QualityLabel,
} from 'atoms/Label/Templates'
import {
  isQualityResolutionToken,
  normalizeQualityToken,
} from 'atoms/Label/Templates/qualityBadgeProps'
import { LABEL_INDENTS } from 'vars/index'
import { LabelGroup } from '../LabelGroup'

export interface ILabelGroupTemplate3MaxLabels6Props extends ILabelGroupProps {
  list: ILabelProps['title'][]
  quality?: string
  dolbyAtmos?: boolean
}

export const LabelGroupTemplate3MaxLabels6 = ({
  list = [],
  columnGap = LABEL_INDENTS.INDENT_10,
  children: _unused,
  alignItems = 'center',
  quality,
  dolbyAtmos,
  ...rest
}: ILabelGroupTemplate3MaxLabels6Props): JSX.Element => {
  const qualityToken = quality ? normalizeQualityToken(quality) : null

  return (
    <LabelGroup columnGap={columnGap} alignItems={alignItems} {...rest}>
      {list?.map((title, i) => {
        if (!title || i >= 6) return null
        if (
          qualityToken &&
          isQualityResolutionToken(title) &&
          normalizeQualityToken(title) === qualityToken
        ) {
          return null
        }
        return isQualityResolutionToken(title) ? (
          <QualityLabel key={`${i}${title}`} title={title} />
        ) : (
          <LabelInlineSecondaryTemplate key={`${i}${title}`} title={title} />
        )
      })}
      {quality && <QualityLabel title={quality} />}
      {dolbyAtmos && <DolbyAtmosLabelIcon />}
    </LabelGroup>
  )
}
